import { TableData, TableDataRow } from '@components/Table/MUITableStyles';
import { device } from '@constants/mediaQueries';
import { faSquareRight } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useMediaQuery } from '@mui/material';
import { ExportButton } from '@pages/OrdersPages/ExportButton';
import { ConfirmationNumber } from '@pages/OrdersPages/styles';
import type { Order } from '@partful/shared-types';
import useFormattedPrice from '@services/formatCurrency';
import { formatDateWithTime } from '@services/formatDate';

interface MyOrdersTableRowProps {
  order: Order;
}

export default function MyOrdersTableRow({ order }: Readonly<MyOrdersTableRowProps>) {
  const date = formatDateWithTime(order.timestamp);
  const isMobile = useMediaQuery(device.mobileOrTablet);

  const totalPriceFormatted = useFormattedPrice({
    price: order.totalPrice.amount,
    currency: order.totalPrice.currencyCode,
  });

  return (
    <TableDataRow data-testid="my-orders-orders-row">
      <TableData>
        <ConfirmationNumber to={`/my-orders/${order.orderId}`} data-testid="confirmationNo-link">
          <FontAwesomeIcon icon={faSquareRight} style={{ marginRight: '.5rem' }} />
          {order.eCommerceOrderName ?? order.orderId}
        </ConfirmationNumber>
      </TableData>
      <TableData>{date}</TableData>
      {!isMobile && (
        <>
          <TableData>{order.companyName}</TableData>
          <TableData>{totalPriceFormatted}</TableData>
          <TableData data-testid="export-to-pdf" sx={{ display: 'flex', gap: 1.5 }}>
            <ExportButton type="pdf" order={order} />
            <ExportButton type="csv" orders={[order]} />
          </TableData>
        </>
      )}
    </TableDataRow>
  );
}
